//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function loadUsersService(status) {
    try {
        const response = await api.get(`/usuarios?status=${status}`);
        return response;
    } catch (err) {
        toast.error("Erro ao carregar usuários");
        return null;
    }
}